<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="list"
      :items-per-page="5"
      item-key="name"
      class="elevation-1"
      :footer-props="{
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title class="mb-2">Pod data Details</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon @click="close">mdi-close</v-icon>
        </v-toolbar>
      </template>
      <template v-slot:[`item.image_or_data`]="{ item }">
        <v-icon @click="open(item.image_or_data, 3)" v-if="item.flag == 3"
          >mdi-eye-outline</v-icon
        >
        <v-icon @click="open(item.image_or_data, 0)" v-if="item.flag == 0"
          >mdi-eye-outline</v-icon
        >

        <v-icon @click="download(item.image_or_data)" v-if="item.flag == 1"
          >mdi-eye-outline</v-icon
        >
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      headers: [
        {
          text: "Name",
          align: "start",
          value: "doc_name",
        },
        { text: "View", value: "image_or_data" },
      ],
    };
  },
  methods: {
    ...mapActions(["downloadInvoiceTemplate"]),
    open(base64String, type) {
      if (type == 0) {
        window.open(base64String, "_blank");
      } else {
        const img = document.createElement("img");

        img.src = "data:image/png;base64," + base64String;
        var w = window.open("");
        w.document.write(img.outerHTML);
      }
    },

    close() {
      this.$emit("close");
    },
    download(file) {
      this.downloadInvoiceTemplate(file).then((res) => {
        this.fileDownload(res, "pdf");
      });
    },
  },
};
</script>
